module.exports = __webpack_public_path__ + "img/cap.2abaea3e.svg";